"use client"

import { Component, type ReactNode } from "react"
import { ErrorBoundary } from "./ErrorBoundary"

interface Props {
  children: ReactNode
  fallback?: (error: Error, resetErrorBoundary: () => void) => ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class ReactErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Error caught by boundary:", error, errorInfo)
  }

  resetErrorBoundary = () => {
    this.setState({ hasError: false, error: null })
  }

  render() {
    if (this.state.hasError && this.state.error) {
      if (this.props.fallback) {
        return this.props.fallback(this.state.error, this.resetErrorBoundary)
      }
      return <ErrorBoundary error={this.state.error} resetErrorBoundary={this.resetErrorBoundary} />
    }

    return this.props.children
  }
}
